export interface LineProps {
    color: string;
    width?: number;
    height?: number;
}

export * from './BallLine';
export * from './BoldBallLine';
export * from './BoldCircleLine';
export * from './BoldLine';
export * from './CircleLine';
export * from './MediumLine';
export * from './NormalLine';
export * from './RectLine';
export * from './SemiBoldLine';
export * from './TransparentRectLine';
